module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-medium-pro-00fb38f1e55bd02da16483be48870e62.woff";